import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LogoutIcon from '@mui/icons-material/Logout';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import NotificationsIcon from '@mui/icons-material/Notifications';
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { Box, Grid, IconButton, ListItemButton, ListItemIcon, Modal, ListItemText, Paper, Typography, useMediaQuery, Button, Menu, MenuItem } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Image from '../../Assets/assetHelper';
import { AuthContext } from '../../Helpers/Contexts/authContext';
import KenColors from '../../Helpers/Themes/kenColors';
import { ReactChildren } from '../../interfaces/Common';
import { AuthUser } from '../../interfaces/Contexts';
import AppBreadCrumbs from '../BreadCrumbs';
import SideNavTabs from './Tabs';
import { useStyles } from './styles';
import routes from '../../Utils/routes';
import MobileNavTabs from './MobileTabs';
import NotificationModal from './NoficationModal';
import CalendarIcon from '../../Assets/icons_calendar.svg';
import SettingIcon from '../../Assets/icons_settings.svg';
import NotificationIcon from '../../Assets/icons_notification.svg';
import { getBasicProfileSetting } from '../../Utils/apiService';

const AppLayout: React.FunctionComponent<ReactChildren> = ({ children }) => {
  const classes = useStyles();
  const {
    state: { user },
    dispatch,
  } = useContext(AuthContext);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const [openNotification, setOpenNotification] = useState(false);
  const [activeIconIndex, setActiveIconIndex] = useState<number | null>(null);
  const [profileUrl, setProfileUrl] = useState('');
  const handleClickIcon = (index: number) => {
    setActiveIconIndex(index === activeIconIndex ? null : index);
  };

  const handleOpenNotification = () => setOpenNotification(true);
  const handleCloseNotification = () => setOpenNotification(false);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width:1025px)');
  const is1980 = useMediaQuery('(max-width:1280px)');

  const userData = user as AuthUser;
  const handleListClick = (path: string, index: number) => {
    console.log('path', path);
    navigate(path);
    if (path == '/login') {
      dispatch({ type: 'LOGOUT' });
    }
  };
  console.log('userData123', userData);

  useEffect(() => {
    getBasicProfileSetting(userData?.applicantId)
      .then((res) => {
        console.log('353454353', res);
        setProfileUrl(res?.accountDetails?.Profile_Picture_URL__c);
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);
  console.log('innerwidth12', window.innerWidth);

  return (
    <>
      {isMobile ? (
        <Grid container spacing={2} sx={{ width: '100vw', height: '100vh' }}>
          <Grid item xs={12} sm={12}>
            <Paper sx={{ mt: 2, ml: 2, mb: 2, p: 1, height: 'auto', boxShadow: 'none !important' }}>
              <Grid item container spacing={2} xs={12} lg={12}>
                <Grid item xs={2}>
                  <div>
                    <Button id="basic-button" aria-controls={open ? 'basic-menu' : undefined} aria-haspopup="true" aria-expanded={open ? 'true' : undefined} onClick={handleClick}>
                      <img
                        className={classes.profilImageMobileView}
                        src={userData?.applicationProfile ? userData.applicationProfile : Image.Images.DefaultProfileImage}
                        alt="profile"
                        style={{ width: '40px', height: '40px', cursor: 'pointer' }}
                        onClick={() => navigate(routes.settings)}
                      />
                    </Button>
                    <Menu
                      id="basic-menu"
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleClose}
                      MenuListProps={{
                        'aria-labelledby': 'basic-button',
                      }}
                    >
                      <MobileNavTabs handleListClick={handleListClick} name="mobile" handleClose={handleClose} />
                    </Menu>
                  </div>
                </Grid>
                <Grid item xs={4} sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                  <AppBreadCrumbs />
                </Grid>
                <Grid item xs={5.5} sx={{ display: 'flex', justifyContent: 'end', mt: 0.5 }}>
                  <img alt="logo" className={classes.actionLogo} src={Image.Images.DefaultOrganizationLogo} />
                  <div style={{ textAlign: 'start', marginTop: 5 }}>
                    <Typography className={classes.actionText}>Ken42</Typography>
                    <Typography className={classes.actionText}>Alumni Suite</Typography>
                  </div>
                </Grid>
              </Grid>
            </Paper>
            <Box
              sx={{
                overflow: 'auto',
                // overflow: isMobile ? 'auto' : 'hidden',
                // height: '100vh',
                // width: '100vw',
                height: '100vh',
                width: '100vw',
                scrollbarColor: 'white',
                p: 2,
                scrollbarWidth: 'none',
              }}
            >
              {children}
            </Box>
          </Grid>
        </Grid>
      ) : (
        <Grid container spacing={3} style={{ padding: isMobile ? '4px 4px' : '20px 0px 20px 20px' }} sx={{ width: '100vw', height: '100vh' }}>
          <Grid item xs={2} md={2}>
            <Paper className={classes.nav}>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: isMobile ? 'center' : '' }}>
                <div style={{ marginBottom: '10px' }}>
                  <img
                    className={classes.profilImage}
                    src={profileUrl ? profileUrl : Image.Images.DefaultProfileImage}
                    alt="profile"
                    style={{
                      width: isMobile ? '40px' : is1980 ? '90px' : '108px',
                      height: isMobile ? '40px' : is1980 ? '90px' : '108px',
                      cursor: 'pointer',
                      borderRadius: '50%',
                      border: '3px solid #3061FF',
                    }}
                    onClick={() => navigate(routes.settings)}
                  />
                  <Typography className={classes.profileName}>{userData?.applicantName ? (isMobile ? userData.applicantName.slice(0, 2).toUpperCase() : userData.applicantName) : ''}</Typography>
                  {userData?.graduationYear !== 'null' && <Typography className={classes.profileDesignation}>Class of {userData?.graduationYear ? userData?.graduationYear : '-'}</Typography>}
                </div>
                <div>
                  <SideNavTabs handleListClick={handleListClick} />
                </div>
              </div>
            </Paper>
          </Grid>
          <Grid item xs={10} md={10}>
            <Grid container spacing={3}>
              <Grid item container spacing={3} xs={12} lg={12}>
                <Grid item xs={6} sm={8} md={8.5} lg={8.5}>
                  <Paper className={classes.header} sx={{ borderRadius: '9px !important' }}>
                    <AppBreadCrumbs />
                  </Paper>
                </Grid>
                <Grid item xs={6} sm={4} md={3.5} lg={3.5}>
                  <Paper className={classes.actions} sx={{ display: 'flex', alignItems: 'center' }}>
                    <IconButton
                      sx={{
                        marginRight: { xs: '4px', sm: '6px', md: '8px', lg: '10px' },
                        backgroundColor: activeIconIndex === 0 ? '#EAEFFF' : 'transparent',
                        color: activeIconIndex === 0 ? '#5981FF' : 'black',
                        '&:hover': {
                          backgroundColor: activeIconIndex === 0 ? '#EAEFFF' : 'transparent',
                        },
                      }}
                      onClick={() => {
                        handleClickIcon(0);
                        navigate(routes.schedule);
                      }}
                    >
                      <img src={CalendarIcon} />
                    </IconButton>
                    <IconButton
                      sx={{
                        marginRight: { xs: '4px', sm: '6px', md: '8px', lg: '10px' },
                        backgroundColor: activeIconIndex === 1 ? '#EAEFFF' : 'transparent',
                        color: activeIconIndex === 1 ? '#5981FF' : 'black',
                        '&:hover': {
                          backgroundColor: activeIconIndex === 1 ? '#EAEFFF' : 'transparent',
                        },
                      }}
                      onClick={() => {
                        handleClickIcon(1);
                        navigate(routes.settings);
                      }}
                    >
                      <img src={SettingIcon} />
                    </IconButton>
                    <IconButton
                      sx={{
                        marginRight: { xs: '4px', sm: '6px', md: '8px', lg: '10px' },
                        backgroundColor: activeIconIndex === 2 ? '#EAEFFF' : 'transparent',
                        color: activeIconIndex === 2 ? '#5981FF' : 'black',
                        '&:hover': {
                          backgroundColor: activeIconIndex === 2 ? '#EAEFFF' : 'transparent',
                        },
                      }}
                      onClick={() => {
                        handleClickIcon(2);
                        handleOpenNotification();
                      }}
                    >
                      <img src={NotificationIcon} />
                    </IconButton>
                    <Modal open={openNotification} onClose={handleCloseNotification} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                      <NotificationModal handleClose={handleCloseNotification} />
                    </Modal>
                    <div style={{ width: '0.75px', height: '45px', background: '#C6C9D2' }} />
                    <img alt="logo" className={classes.actionLogo} src={Image.Images.DefaultOrganizationLogo} />
                    <div style={{ textAlign: 'start' }}>
                      <Typography className={classes.actionText}>Ken42</Typography>
                      <Typography className={classes.actionText}>Alumni Suite</Typography>
                    </div>
                  </Paper>
                </Grid>
              </Grid>
              <Box
                sx={{
                  overflow: 'auto',
                  // overflow: isMobile ? 'auto' : 'hidden',
                  // height: '100vh',
                  // width: '100vw',
                  height: `calc(100vh - 75px)`,
                  width: `calc(100vw - 30px)`,
                  scrollbarColor: 'white',
                  paddingTop: '3px',
                  paddingLeft: '22px',
                  scrollbarWidth: 'none',
                }}
              >
                {children}
              </Box>
            </Grid>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default AppLayout;
